module.exports = __webpack_public_path__ + "img/hamburger.261b63a8.svg";